import React from 'react';
import { Link  } from "react-router-dom";
import {translate, gotoUrl,resolveRouterPath, updateNestedObject} from 'utils/common';
import dataService from 'utils/dataservice'; 
import { Dropdown, DropdownToggle, DropdownMenu, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';  
import { UPDATE_ADDRESS } from 'utils/constants';
// import 'assets/sass/content.scss'; 
import { Input } from './inputfields';
import classnames from 'classnames';
const CONF = {
  PROVINCE: {key:'PROVINCE',field:'province_code',fieldList:'provinceList', name:'province_name'}, 
  DISTRICT: {key:'DISTRICT',field:'district_code',fieldList:'districtList', name:'district_name'}, 
  SUBDISTRICT: {key:'SUBDISTRICT',field:'subdistrict_code',fieldList:'subDistrictList', name:'subdistrict_name'},
  POSTCODE: {key:'POSTCODE',field:'postcode',fieldList:'postCodeList'},
  PROVINCENAME:'province_name',
  DISTRICTNAME:'district_name',
  SUBDISTRICTNAME:'subdistrict_name'
}
const SEARCH_LIMIT = 200, DEFAULT_SEARCH_LIMIT = 100;

class AddressComp extends React.Component { 

  constructor(props) {
    super(props);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.doAddressSearch = this.doAddressSearch.bind(this);
    this.initialSearch = this.initialSearch.bind(this);
    this.selectCity = this.selectCity.bind(this);
    this.selectDistrict = this.selectDistrict.bind(this);
    this.selectSubDistrict = this.selectSubDistrict.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    // this.validateAddressInputs = this.validateAddressInputs.bind(this);
    this.getStateData = this.getStateData.bind(this);
    this.triggerOnchange = this.triggerOnchange.bind(this);
    this.initAddressSearch = this.initAddressSearch.bind(this);
    this.getSelectedAddress = this.getSelectedAddress.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    var customprops={}
    this.subscribedEvents = app.events.subscribe({
        [UPDATE_ADDRESS] : this.updateAddress
    });
    if(this.props.type == 'district'){
        customprops.type= CONF.DISTRICT.key;
        customprops.hideCity = true
    }
    this.state = { ...this.getStateData(this.props.value), type:CONF.PROVINCE.key, suggestions: [],
                   ...this.initAddressSearch(), ...customprops };
    // this.state = { ...this.getStateData(this.props), validation: this.validator.valid(), suggestions: [], ...this.initAddressSearch() };
}
  componentDidMount(){ 
  }
  componentDidUpdate(prevProps){
      let {value}= this.props;
        if(prevProps.value != this.props.value ){ 
            let valueprops = {
            province: this.state.province || value && value.province || '',
            provinceName: this.state.provinceName || value && value.provinceName || '',
            district: this.state.district || value && value.district || '',
            districtName: this.state.districtName || value && value.districtName || '',
            subDistrict: this.state.subDistrict || value && value.subDistrict || '',
            subDistrictName: this.state.subDistrictName || value && value.subDistrictName || '',
        }
        // let arr= [[...{valueprops.city, valueprops.districtName, valueprops.subDistrictName}]]; 
        //TODO///array operation es6
        let arr= [];
        if(valueprops.provinceName) arr.push(valueprops.provinceName)
        if(valueprops.districtName) arr.push(valueprops.districtName)
        if(valueprops.subDistrictName) arr.push(valueprops.subDistrictName); 
        let selectedAddress = arr.join(' , ');// `${valueprops.city}, ${valueprops.districtName}, ${valueprops.subDistrictName}`;
        this.setState({ ...valueprops, selectedAddress});        
    }
  }
  updateAddress(data) {
      if(data[0].updatedAddress) {
        var updatedAddress = data[0].updatedAddress;
        var stateValue = this.state;
        stateValue.fullName = updatedAddress.fullName || '',
        stateValue.addressLine1 =  updatedAddress.addressLine1 || '',
        stateValue.zipCode= updatedAddress.zipCode || this.state.zipCode ||  '',
        stateValue.province= updatedAddress.province ||  '',
        stateValue.provinceName= updatedAddress.provinceName || '',
        stateValue.district= updatedAddress.district || '', 
        stateValue.districtName= updatedAddress.districtName || '', 
        stateValue.subDistrict = updatedAddress.subDistrict || '',
        stateValue.subDistrictName = updatedAddress.subDistrictName || '',
        stateValue.phoneNo= updatedAddress.phoneNo || '',
        stateValue.defaultAddress=( (updatedAddress && !!updatedAddress.defaultAddress) || this.props.singleRecord),
        stateValue.addressIdfier=this.props.addressIdfier || null,
        stateValue.selectedAddress= this.getSelectedAddress();
        this.setState({stateValue : stateValue});
      }
  }
  getStateData(addr){
    return {
        fullName: addr && addr.fullName || '',
        addressLine1: addr && addr.addressLine1 || '',
        zipCode: addr && addr.zipCode || '',

        province: addr && addr.province || '',
        provinceName: addr && addr.provinceName || '',
        district: addr && addr.district || '', 
        districtName: addr && addr.districtName || '', 
        subDistrict: addr && addr.subDistrict || '',
        subDistrictName: addr && addr.subDistrictName || '',

        phoneNo: addr && addr.phoneNo || '',
        defaultAddress:( (addr && !!addr.defaultAddress) || this.props.singleRecord),
        addressIdfier:this.props.addressIdfier || null,
        selectedAddress: this.getSelectedAddress()
        // selectedAddress: this.props.value?(`${this.props.value.city} , ${this.props.value.districtName} , ${this.props.value.subDistrictName}`):''
    };
  }
//   validateAddressInputs(fieldValue, data) {
//     if (data.city && data.districtName && data.subDistrictName) {
//         return true;
//     }
//     return false;
//   }
  initAddressSearch() {
      return {
          dropdownOpen: false,
        //   activeTab: CONF.PROVINCE.key,
          activeTab: this.props.type == 'district'? CONF.DISTRICT.key:CONF.PROVINCE.key,
          provinceList: [],
          districtList: [],
          subDistrictList: [],
          postcodeList: [],
          searchInpValue: '',
          //selectedAddress: this.props.value?(`${this.props.value.city || ''} , ${this.props.value.districtName || ''} , ${this.props.value.subDistrictName || ''}`):''
       };
  }
  toggleDropDown() {
      this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen, searchInpValue:'' }));
  }
  toggleTab(tab) {
      if (this.state.activeTab !== tab){
          this.setState({ activeTab: tab, searchInpValue:''});
      }
      const fieldList = CONF[tab].fieldList || '';
      if(this.state[fieldList] && this.state[fieldList].length < 1){
          this.handleSearchInput(null,tab);
      }        
  }
  initialSearch() {
      const data = {
        //   queryField: CONF.PROVINCE.field,
          queryField: CONF[this.state.type].name,
          queryValue: '',
        //   resultFieldList: [CONF.PROVINCE.field],
        //   orderBy: CONF.PROVINCE.field,
          resultFieldList: this.state.type== CONF.DISTRICT.key?[CONF.DISTRICTNAME, CONF.DISTRICT.field]:[CONF.PROVINCENAME, CONF[this.state.type].field],
          orderBy: CONF[this.state.type].name,
          filters: {}
      }
      this.doAddressSearch(data, CONF[this.state.type].fieldList);
  }
  doAddressSearch(data, field) {
      data['loader'] = false;
      data['limit'] = field == CONF.SUBDISTRICT.fieldList ? SEARCH_LIMIT : DEFAULT_SEARCH_LIMIT;
      data['locale'] = app.selectedLocale;
      data['orgIdfier'] = "scg";
      data['userType'] = "SELLER";
      dataService.postRequest('searchAddress', data).then(res => {
          res && res.length > 0 && this.setState({
              [field]: res
          }, () => {
              if (field == CONF.POSTCODE.fieldList) {
                  this.setState({ zipCode: res[0][CONF.POSTCODE.field] || '' },()=>{
                    this.triggerOnchange();
                  });
                  this.toggleDropDown();
              }
          });
          
      }).catch(res => {
          //this.handleError(res.error,res.errorCode);
      });
  }
  triggerOnchange(){
    if(this.props.onChange) this.props.onChange({target:{ inputtype:'address', name: this.props.name, 
          value:{province: this.state.province, provinceName: this.state.provinceName,
                district: this.state.district, districtName:this.state.districtName,
                subDistrict: this.state.subDistrict, subDistrictName:this.state.subDistrictName,
                postalCode:this.state.zipCode}  }}); 
  }
  getSelectedAddress(){
    let arr= [];
    let provinceName = this.state? this.state.provinceName : (this.props.value && this.props.value.provinceName) || ''
    let districtName = this.state? this.state.districtName : (this.props.value && this.props.value.districtName) || ''
    let subDistrictName = this.state? this.state.subDistrictName : (this.props.value && this.props.value.subDistrictName) || ''
    if(provinceName) arr.push(provinceName)
    if(districtName) arr.push(districtName)
    if(subDistrictName) arr.push(subDistrictName); 
     
    return arr.join(' , ');
  }
  selectCity(event) {
      const provinceName = event.currentTarget.name || '';
      const province = event.currentTarget.id || '';
      this.setState({ province, provinceName,
        //selectedAddress: city,
        district:'', subDistrict:'' ,
        districtName:'', subDistrictName:'', zipCode:'', districtList:[],subDistrictList:[] }, () => {
            this.setState({selectedAddress: this.getSelectedAddress()})
            this.triggerOnchange();
            this.toggleTab(CONF.DISTRICT.key);
      });
  }
  selectDistrict(event) {
      const districtName = event.currentTarget.name || '';
      const district = event.currentTarget.id || '';
      //let selectedAddress = this.state.city + ', ' + districtName;
      this.setState({ districtName, district,
        subDistrict:'' ,
        subDistrictName:'', zipCode:'',subDistrictList:[] }, () => {
            this.setState({selectedAddress: this.getSelectedAddress()})
            this.triggerOnchange();
            this.toggleTab(CONF.SUBDISTRICT.key);
      });
  }
  selectSubDistrict(event) {
      const subDistrictName = event.currentTarget.name || '';
      const subDistrict = event.currentTarget.id || '';
    //   let selectedAddress = this.state.city + ', ' + this.state.districtName + ', ' + subDistrictName;
      this.setState({ subDistrictName,  subDistrict,
        // selectedAddress, 
         }, () => {
            this.setState({selectedAddress: this.getSelectedAddress()})
            this.triggerOnchange();
            let filters= { [CONF.PROVINCE.field]: this.state.province, [CONF.DISTRICT.field]: this.state.district, 
                           [CONF.SUBDISTRICT.field]: this.state.subDistrict };
            if(!this.state.province) delete filters[[CONF.PROVINCE.field]]
            const data = {
                queryField: CONF.POSTCODE.field,
                queryValue: "",
                resultFieldList: [CONF.POSTCODE.field],
                orderBy: CONF.POSTCODE.field,
                filters: filters
            }
            this.doAddressSearch(data, CONF.POSTCODE.fieldList)
      });
  }
  handleSearchInput(event,tab) {
    let value = event ? event.currentTarget.value || '' : '';
    const option = event ? this.state.activeTab : tab;
    this.setState({ searchInpValue: value });
    value = value.trim().toLowerCase();
    let data, field, filters;
    switch (option) {
        case CONF.PROVINCE.key:
            this.setState({provinceList:[]});
            data = {
                queryField: CONF.PROVINCE.name,
                queryValue: value,
                resultFieldList: [CONF.PROVINCENAME, CONF.PROVINCE.field],
                orderBy: CONF.PROVINCE.name,
                filters: {}
            }
            field = CONF.PROVINCE.fieldList;
            break;
        case CONF.DISTRICT.key:
            this.setState({districtList:[]});
            filters= { [CONF.PROVINCE.field]: this.state.province };
            if(!this.state.province) delete filters[[CONF.PROVINCE.field]]
            data = {
                queryField: CONF.DISTRICT.name,
                queryValue: value,
                resultFieldList: [CONF.DISTRICTNAME, CONF.DISTRICT.field],
                orderBy: CONF.DISTRICT.name,
                filters: filters
            }
            field = CONF.DISTRICT.fieldList;
            break;
        case CONF.SUBDISTRICT.key:
            this.setState({subDistrictList:[]});
            filters= { [CONF.PROVINCE.field]: this.state.province, [CONF.DISTRICT.field]: this.state.district };
            if(!this.state.province) delete filters[[CONF.PROVINCE.field]]
            data = {
                queryField: CONF.SUBDISTRICT.name,
                queryValue: value,
                resultFieldList: [CONF.SUBDISTRICTNAME, CONF.SUBDISTRICT.field],
                orderBy: CONF.SUBDISTRICT.name,
                filters: filters
            }
            field = CONF.SUBDISTRICT.fieldList;
            break;
    }
    this.doAddressSearch(data, field);
  }
  
  render(){
    return(
      <div className=" multi-select">
        {/* <label>{translate('buyer.address.address_fields')}</label> */}
        <Dropdown isOpen={this.state.dropdownOpen} toggle={!this.props.readOnly?this.toggleDropDown:null}>
            <DropdownToggle tag="div" caret>
              <Input
                onClick={this.initialSearch}
                value={this.state.selectedAddress}
                id="addSearch"
                name="addSearchInp"
                type="text"
                fieldClassName="dropdown-toggle form-control"
                placeholder={translate('seller.address.please_select_lbl')}
                extraPops={{ readOnly: true }}
                // validator={validation} 
                />
            </DropdownToggle>
            <DropdownMenu className="p-3">
                <Nav tabs>
                    {!this.state.hideCity && <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === CONF.PROVINCE.key })} onClick={() => { this.toggleTab(CONF.PROVINCE.key); }}>
                            {this.state.provinceName || translate('seller.province')}
                        </NavLink>
                    </NavItem>}
                    {(this.state.type== CONF.DISTRICT.key || this.state.province) && <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === CONF.DISTRICT.key })} onClick={() => { this.toggleTab(CONF.DISTRICT.key); }} >
                            {this.state.districtName || translate('seller.district')}
                        </NavLink>
                    </NavItem>}
                    {(this.state.type== CONF.DISTRICT.key || this.state.province) && this.state.districtName && <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === CONF.SUBDISTRICT.key })} onClick={() => { this.toggleTab(CONF.SUBDISTRICT.key); }} >
                            {this.state.subDistrictName || translate('seller.subdistrict')}
                        </NavLink>
                    </NavItem>}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                        <div className="m-3"> 
                            <Input onChange={this.handleSearchInput} value={this.state.searchInpValue} id="searchInp" type="text" placeholder={translate('search')} />
                        </div>
                    {/* {!this.state.hideCity &&   */}
                    <TabPane tabId={CONF.PROVINCE.key}>
                        {this.state.provinceList.map((item, i) =>
                            <a key={i} onClick={this.selectCity} id={item[CONF.PROVINCE.field]} name={item["province_name"]}
                                className={"dropdown-item " + (this.state.province == item[CONF.PROVINCE.field] ? 'active' : '')}>{item["province_name"]}</a>
                        )}
                        </TabPane>
                   {/* } */}
                    <TabPane tabId={CONF.DISTRICT.key}>
                        {this.state.districtList.map((item, i) =>
                            <a key={i} onClick={this.selectDistrict} id={item[CONF.DISTRICT.field]} name={item["district_name"]} 
                                className={"dropdown-item " + (this.state.districtName == item[CONF.DISTRICT.field] ? 'active' : '')}>{item["district_name"]}</a>
                        )}
                    </TabPane>
                    <TabPane tabId={CONF.SUBDISTRICT.key}>
                        {this.state.subDistrictList.map((item, i) =>
                            <a key={i} onClick={this.selectSubDistrict} id={item[CONF.SUBDISTRICT.field]} name={item["subdistrict_name"]} 
                            className={"dropdown-item " + (this.state.subDistrictName == item[CONF.SUBDISTRICT.field] ? 'active' : '')}>{item["subdistrict_name"]}</a>
                        )}
                    </TabPane>
                </TabContent>
            </DropdownMenu>
        </Dropdown>
      </div>
    );
  }    
}
export default AddressComp;